/**
 * defa.routers.SubscriptionRouter
 * The router for the SubscriptionController
 * @version 1.2.0
 */
const SubscriptionRouter = Mn.AppRouter.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	appRoutes: {
		'subscriptions/:id/replace(/)'  : 'showSubscriptionReplace',
		'subscriptions/:id/terminate(/)': 'showSubscriptionTerminate',
		'subscriptions/:id/transfer(/)' : 'showSubscriptionTransfer',
		'subscriptions/:id(/)'          : 'showSubscription',
	},
	
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
} );

export default SubscriptionRouter;